import React, { useState } from 'react';
import Layout from '../components/Layout';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { RoutesEnum } from '../routes/RoutesEnum';
import { getButtonPrimaryStyleClass } from '../config/FormSettings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faPlay } from '@fortawesome/free-solid-svg-icons';
import VideoIframe from '../shared/components/VideoIframe';
import MapEBC from '../shared/components/Map';
import CategoriesMod from '../shared/components/CategoriesMod';

const Home: React.FC = () => {
  const [isDisplayVideo, setIsDisplayVideo] = useState<boolean>(false);

  return (
    <Layout>
      <Helmet>
        <title>goo.pet - Sell or Buy Businesses, List your Business Services & Products, etc.</title>
      </Helmet>

      <div className="container relative mt-10 mb-20">
        <CategoriesMod />
      </div>
    </Layout>
  );
};

export default Home;